export default __webpack_public_path__ + "static/media/JUNEDOM2026.72f5255e.png";